import { createSelector } from '@reduxjs/toolkit';

export const getSearch = ()=> {
    return createSelector(
        (state) => state.search_result,
        (state) => state
    )
}